import SimulationPage from '@/features/simulation/page'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authed/simulation')({
  component: SimulationPage,
})
